import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError, of, BehaviorSubject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ServiceService {


  // constructor(private http: HttpClient, public router: Router) { }
  private apiUrl = 'https://c4cteams.my3cx.sg:4003/api/getTestingJson.php';
  private apiUrl1 = 'http://127.0.0.1:8000/api/chettinadu';
  private apiUrl2 = 'http://127.0.0.1:8000/api/date';
  private url = './assets/value.json'
  private otpData: { [key: string]: { otp: string; expiresAt: number } } = {};
  private renderer: Renderer2;
  private overlay: HTMLElement | null = null;
  constructor(private http: HttpClient, private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  //   sendServer2(body: string, headers: HttpHeaders) {
  //     const httpOptions = {
  //         headers: new HttpHeaders({
  //             'Content-Type': 'application/x-www-form-urlencoded',
  //         })
  //     };
  // return this.http.post("https://43.225.167.54:2480/umapi2.php", body, httpOptions);



  generateOtp(mobile: string): string {
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    const expiresAt = Date.now() + 2 * 60 * 1000; // 2 minutes expiry
    this.otpData[mobile] = { otp, expiresAt };
    // console.log(`OTP for ${mobile}: ${otp}`);

    return otp;
  }

  verifyOtp(mobile: any, enteredOtp: any) {
    // const data = this.otpData[mobile];
    // if (!data) return false;
    // return data.otp === enteredOtp && Date.now() < data.expiresAt;

    const api_req = {
      action: "verify_otp",
      phone_number: mobile,
      otp_value: enteredOtp
    };

    const headers = {
      'Content-Type': 'application/json'
    };

    const url = 'https://chettinadlink.com/zoho-apis/';
    return this.http.post(url, api_req, { headers });

  }

  sendOtpSms(mobile: string, otp: string) {
    const api_req = {
      action: "get_otp",
      phone_number: mobile,
      // otp_value: btoa(otp)
    };

    const headers = {
      'Content-Type': 'application/json'
    };

    const url = 'https://chettinadlink.com/zoho-apis/';
    return this.http.post(url, api_req, { headers });
  }

  processPayment(data: any) {
    const paymentUrl = 'https://chettinadlink.com/zoho-apis/invoice_payment.php';
    return this.http.post(paymentUrl, data);
  }

  getChartData(): Observable<any> {

    return this.http.get(this.apiUrl);
  }

  getUserdata() {
    return this.http.get(this.apiUrl1);
  }
  getuserdates() {
    return this.http.get(this.apiUrl2);
  }

  getuserpostdata(data: any): Observable<any> {
    return this.http.post(this.apiUrl1, data);
  }

  getjsondata() {
    return this.http.get(this.url);
  }

  sendServer2(body: string, headers: HttpHeaders) {
    const httpOptions = { headers };
    return this.http.post("https://chettinadlink.com/zoho-apis/", body, httpOptions);
  }

  sendzohoServer(body: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const httpOptions = { headers };
    return this.http.post("https://chettinadlink.com/zoho-apis/", body, httpOptions);
  }



  // sendProfileServer(body: any) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json'
  //   });
  //   const httpOptions = { headers };

  //   return this.http.post("https://chettinadlink.com/zoho-apis/", body, httpOptions);
  // }


  private profileImageSource = new BehaviorSubject<string>(localStorage.getItem('profile_image') || '');
  currentProfileImage$ = this.profileImageSource.asObservable();

  setProfileImage(image: string) {
    localStorage.setItem('profile_image', image);
    this.profileImageSource.next(image);
  }



}



